export const NAME_FIELDS = [
  'firstName',
  'middleName',
  'lastName',
  'alternativeFirstName',
  'alternativeLastName',
]
